import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'

export function optionSelection(action: string, value: any) {
  try {
    const metrics = getMetrics()
    metrics.api.track(EventTypes.CUSTOM_ACTION, {
      event_action: action,
      event_category: 'option',
      value,
    })
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}
